<div class="sm-text-secondary-text">
  <small i18n>Created:</small>
  <small>{{ field.content | amDateFormat : 'lll' }}</small>
</div>
